module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-ru-RU.3a01f6d3.jpg";